export const INTERNSHIP_APP_API = process.env.REACT_APP_INTERNSHIP_APP_API;
